import { useSite } from '@/app/providers/SiteProvider';
import { usePublicMenu } from '@/features/themes/lib/useSiteMenu';
import { PublicMenuNav } from '@/features/public-site/components/PublicMenuNav';
import { ResponsiveMenuNav } from '@/features/public-site/components/ResponsiveMenuNav';
import { getTextStyle } from '../lib/textStyle';
import { usesHamburger, type MenuBlock } from '@/types/blocks';

/** Preview no editor admin — usa o site ativo (SiteProvider). */
export function AdminMenuBlock({ block, compact = false }: { block: MenuBlock; compact?: boolean }) {
  const { siteId } = useSite();
  const { data: menu } = usePublicMenu(siteId);

  if (!menu || menu.length === 0) {
    return (
      <p className="rounded-lg border border-dashed border-border p-3 text-sm text-muted">
        Nenhum item de menu criado ainda. Configure em Aparência → Menu de navegação.
      </p>
    );
  }

  const nav = usesHamburger(block) ? (
    // interactive={false}: o painel usa portal em document.body e cobriria a UI do CMS.
    <ResponsiveMenuNav
      menu={menu}
      siteSlug="preview"
      align={block.align}
      dropdownRadius={block.dropdownRadius}
      hamburgerColor={block.hamburgerColor}
      backgroundColor={block.backgroundColor}
      backgroundOpacity={block.backgroundOpacity}
      dropdownBackgroundColor={block.dropdownBackgroundColor}
      dropdownHoverBackgroundColor={block.dropdownHoverBackgroundColor}
      dropdownTextColor={block.dropdownTextColor}
      textStyle={getTextStyle(block)}
      interactive={false}
    />
  ) : (
    <PublicMenuNav menu={menu} siteSlug="preview" style={block.style} align={block.align} dropdownRadius={block.dropdownRadius} dropdownBackgroundColor={block.dropdownBackgroundColor} dropdownHoverBackgroundColor={block.dropdownHoverBackgroundColor} dropdownTextColor={block.dropdownTextColor} backgroundColor={block.backgroundColor} backgroundOpacity={block.backgroundOpacity} textStyle={getTextStyle(block)} />
  );

  // A borda tracejada serve de alvo de seleção no canvas, mas poluiria o
  // preview de um header montado com divs.
  if (compact) return nav;
  return <div className="rounded-lg border border-dashed border-border p-3">{nav}</div>;
}

/** Render no site público — recebe siteId/siteSlug explícitos (sem SiteProvider). */
export function PublicMenuBlock({
  block,
  siteId,
  siteSlug,
  compact = false,
}: {
  block: MenuBlock;
  siteId: string;
  siteSlug: string;
  /** Dentro de uma div, espaçamento e largura são do container — sem seção própria. */
  compact?: boolean;
}) {
  const { data: menu } = usePublicMenu(siteId);
  if (!menu || menu.length === 0) return null;

  const nav = usesHamburger(block) ? (
    <ResponsiveMenuNav
      menu={menu}
      siteSlug={siteSlug}
      align={block.align}
      dropdownRadius={block.dropdownRadius}
      hamburgerColor={block.hamburgerColor}
      backgroundColor={block.backgroundColor}
      backgroundOpacity={block.backgroundOpacity}
      dropdownBackgroundColor={block.dropdownBackgroundColor}
      dropdownHoverBackgroundColor={block.dropdownHoverBackgroundColor}
      dropdownTextColor={block.dropdownTextColor}
      textStyle={getTextStyle(block)}
    />
  ) : (
    <PublicMenuNav menu={menu} siteSlug={siteSlug} style={block.style} align={block.align} dropdownRadius={block.dropdownRadius} dropdownBackgroundColor={block.dropdownBackgroundColor} dropdownHoverBackgroundColor={block.dropdownHoverBackgroundColor} dropdownTextColor={block.dropdownTextColor} backgroundColor={block.backgroundColor} backgroundOpacity={block.backgroundOpacity} textStyle={getTextStyle(block)} />
  );

  if (compact) return nav;
  return (
    <section className="w-full py-6">
      <div className="mx-auto max-w-4xl px-6">{nav}</div>
    </section>
  );
}
